export const getDetailsList = (state) => state.manageRequestBookings.detailsList?.data;
export const getResetList = (state) => state.manageRequestBookings?.isReset;
